import { setUrl } from "./endpoint-helper.ts";

const EXTRACTION_ENDPOINT = {
    GET_BAAMER_REVISION_EXTRACTION: (baamerRevisionId : string) => setUrl(`/extractionSheets/baamerRevision/${baamerRevisionId}`),
    SAVE_BAAMER_REVISION_EXTRACTION: (baamerRevisionId : string) => setUrl(`/extractionSheets/baamerRevision/${baamerRevisionId}`),
    
    EXPORT_EXCEL: () => setUrl('/extractionSheets/exportExcel')
};

export default EXTRACTION_ENDPOINT;